import { deleteCookie, readCookie, writePersistentCookie } from "common/utils/cookie";

export default class DesignUploadCtaPlpCookieClass {
  static #cookieName = "upload_design_on_print_plp";

  static get #cookie() {
    const props = readCookie(DesignUploadCtaPlpCookieClass.#cookieName);
    if (!props) return null;

    try {
      return JSON.parse(atob(props));
    } catch (error) {
      // If decoding fails due to malformed cookie, delete it and return empty string
      deleteCookie(DesignUploadCtaPlpCookieClass.#cookieName);
      return null;
    }
  }

  static set cookie(props) {
    if (props) {
      // Ensure props is an object and has the necessary properties
      if (
        typeof props !== "object" ||
        !props.id ||
        !props.url ||
        !props.original_image_url ||
        !props.original_mime
      ) {
        throw new Error(
          `Invalid props provided for DesignUploadCtaPlpCookieClass.cookie ${JSON.stringify(props)}`
        );
      }
      writePersistentCookie(DesignUploadCtaPlpCookieClass.#cookieName, btoa(JSON.stringify(props)));
    } else {
      deleteCookie(DesignUploadCtaPlpCookieClass.#cookieName);
    }
  }

  static updateCookie(props) {
    const cookie = DesignUploadCtaPlpCookieClass.#cookie || {};
    if (props && typeof props === "object") {
      writePersistentCookie(
        DesignUploadCtaPlpCookieClass.#cookieName,
        btoa(
          JSON.stringify({
            ...cookie,
            ...props
          })
        )
      );
    }
  }

  static destroy() {
    DesignUploadCtaPlpCookieClass.cookie = null;
  }

  static get previewUrl() {
    const { url } = DesignUploadCtaPlpCookieClass.#cookie || {};
    return url || "";
  }

  static get originalUrl() {
    const { original_image_url: originalUrl } = DesignUploadCtaPlpCookieClass.#cookie || {};
    return originalUrl || "";
  }

  static get previewId() {
    const { id } = DesignUploadCtaPlpCookieClass.#cookie || {};
    return id || "";
  }

  static get originalFiletype() {
    const { original_mime: filetype } = DesignUploadCtaPlpCookieClass.#cookie || {};
    return filetype || "";
  }

  static get updatedAt() {
    const { updated_at: updatedAt } = DesignUploadCtaPlpCookieClass.#cookie || {};
    return updatedAt || "";
  }
}
